var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container container-footer bg-gray"},[_c('section',{staticClass:"staff-nav"},[_c('van-tabs',{attrs:{"type":"card","sticky":""}},[_c('van-tab',{attrs:{"title":"我的员工"}},[_c('employee')],1),_c('van-tab',{attrs:{"title":"我的就业队长"}},[_c('leader')],1)],1)],1),_c('tab-bar')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }